import { BasePage } from "components/BasePage/BasePage";
import { PlanSelection } from "./PlanSelection";

export const CheckoutTest = () => {
  return (
    <BasePage
      breadcrumbItems={[
        { label: "Backoffice", location: "/_backoffice" },
        {
          label: "Test Checkout",
          location: "/_backoffice/_risks",
        },
      ]}
    >
      <div>
        <div className="pb-5 border-b border-gray-200 sm:flex sm:items-center sm:justify-between">
          <h3 className="text-3xl leading-6 font-medium text-gray-900">
            ! CHECKOUT TEST !
          </h3>
        </div>

        <section>
          <PlanSelection />
        </section>
      </div>
    </BasePage>
  );
};

export default CheckoutTest;
